import { Component, Input, OnInit } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { PostListingCategory } from "src/app/types/post";

@Component({
  selector: "app-select-list",
  templateUrl: "./select-list.component.html",
  styleUrls: ["./select-list.component.scss"],
})
export class SelectListComponent implements OnInit {
  filterByCategory: PostListingCategory;
  expandedCategory: PostListingCategory;
  allLabel: string = "All Categories";

  @Input() data: any[];
  @Input() label: string;
  @Input() hideReset: boolean = false;

  constructor(private popoverController: PopoverController) {}

  async dismissPopover() {
    await this.popoverController.dismiss();
  }

  /**
   * Select catagory for filter
   */
  selectCategory(item) {
    this.filterByCategory = item;
    this.popoverController.dismiss(this.filterByCategory);
  }

  /**
   * Expand parent category to reveal children category
   */
  expandCategory(item) {
    if (this.expandedCategory != item) {
      this.expandedCategory = item;
    } else {
      this.selectCategory(item);
    }
  }

  ngOnInit() {
    if (this.label) this.allLabel = this.label;
  }
}
